import paymentInstance from '../../instance'
import paymentModalLoginInstance from '../../modalLoginInstance'

const simulateTerminalPayment = (terminalId, data, hasModalLogin) => {
	return (hasModalLogin ? paymentModalLoginInstance : paymentInstance).post(`/terminals/${terminalId}/simulate`, data)
}

export default simulateTerminalPayment
